/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Vepara
 */
export class Vepara {
    /**
     *
     * @type {string}
     * @memberof Vepara
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Vepara
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Vepara
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Vepara
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Vepara
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Vepara
     */
    domain: string;
    /**
     *
     * @type {boolean}
     * @memberof Vepara
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Vepara
     */
    autoApprove: boolean;
}
